import request from '@/utils/request';

// 查询角色列表
export function listRole(query) {
  return request({
    url: '/system/role/list',
    method: 'get',
    params: query
  });
}

// 查询医院拖修车角色列表
export function getListRole() {
  return request({
    url: '/system/user/getUserByRoles',
    method: 'get'
  });
}
